class Person {
    constructor(apiConfig, http) {
        const { siteInfo } = apiConfig;
        const { storeId } = siteInfo;
        this.apiConfig = apiConfig;
        this.http = http;
        this.path = `/wcs/resources/store/${storeId}`;
    }

    get() {
        return this.http(`${this.path}/person/@self`).then(({ data, status }) => {
            if (data && data.userId === '-1002') {
                data.isGuest = true;
            }
            return data;
        });
    }

    setGuestIdentity() {
        return this.http
            .post(`${this.path}/guestidentity?updateCookies=true`, { params: { updateCookies: true } })
            .then(({ data, status }) => {
                return data;
            });
    }
}

export default Person;
